<template>
    <div>
        <convenio-documentos :convenio="convenio"></convenio-documentos>
        <b-card no-body>
            <b-card-header>
                <span class="h5"> Prestação de Contas Mensal </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela
                        idTabela="tblPrestacaoContasMensal"
                        :itens="listaPrestacoes"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false"
                    >
                        <template slot="botoes">
                            <b-button-group
                                class="float-right"
                                v-if="$temAcesso('GESCON-FORN-CONV-03')"
                            >
                                <Cad-Prestacao-Mensal
                                    :idConvenio="convenio.idConvenio"
                                    :idSituacaoConvenio="
                                        convenio.idSituacaoConvenio
                                    "
                                    class="mr-2"
                                    @atualizarLista="CarregarLista()"
                                >
                                </Cad-Prestacao-Mensal>
                            </b-button-group>
                        </template>

                        <template slot="acoes" slot-scope="data">
                            <span
                                class="text-danger float-left mr-1"
                                v-if="$temAcesso('GESCON-FORN-CONV-04')"
                            >
                                <i
                                    class="fa fa-trash fa-lg icon-button"
                                    title="Excluir"
                                    v-if="
                                        data.codSituacao != 3 &&
                                        convenio.idSituacaoConvenio != 9
                                    "
                                    @click.stop="
                                        Excluir(data.IdPrestacaoContasFinal)
                                    "
                                ></i>
                            </span>
                            <span
                                class="text-primary float-left mr-1"
                                v-if="$temAcesso('GESCON-FORN-CONV-06')"
                            >
                                <prestacao-final
                                    class="mr-2"
                                    :idPrestacaoMensal="
                                        data.idPrestacaoContasMensal
                                    "
                                    :convenio="convenio"
                                    @atualizarLista="atualizarLista()"
                                >
                                </prestacao-final>
                            </span>
                        </template>

                        <template slot="dtCompetencia" slot-scope="data">
                            <p class="text-left m-0">
                                {{
                                    data.dtCompetencia
                                        ? $moment(data.dtCompetencia).format(
                                              'MM/YYYY'
                                          )
                                        : ''
                                }}
                            </p>
                        </template>

                        <template slot="dtPrestacao" slot-scope="data">
                            <p class="text-left m-0">
                                {{
                                    data.dtPrestacao
                                        ? $moment(data.dtPrestacao).format(
                                              'DD/MM/YYYY'
                                          )
                                        : ''
                                }}
                            </p>
                        </template>

                        <template slot="nuTotalGasto" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuTotalGasto | currency }}
                            </p>
                        </template>

                        <template slot="nuTotalRendimentos" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuTotalRendimentos | currency }}
                            </p>
                        </template>

                        <template slot="nuReceitasDiversas" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuReceitasDiversas | currency }}
                            </p>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from '../ConvenioServicos'
import CadPrestacaoMensal from '../cadastros/CadPrestacaoContasMensal'
import PrestacaoFinal from './ConvenioDadosDespesa'
import ConvenioDocumentos from './ConvenioDocumentos'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        CadPrestacaoMensal,
        PrestacaoFinal,
        ConvenioDocumentos
    },

    data() {
        return {
            listaPrestacoes: [],
            itensPorPagina: 5,
            campos: [
                {
                    key: 'idPrestacaoContasMensal',
                    label: 'Id',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtCompetencia',
                    label: 'Competência',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtPrestacao',
                    label: 'Data Prestação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuTotalGasto',
                    label: 'Total Despesas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuTotalRendimentos',
                    label: 'Total Rendimentos',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuReceitasDiversas',
                    label: 'Receitas Diversas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'situacao',
                    label: 'Situacao',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        CarregarLista() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarPrestacoesContas(
                this.$route.params.idConvenio
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.listaPrestacoes = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        Excluir(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ExcluirPrestacaoMensal(id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.CarregarLista()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.CarregarLista()
    }
}
</script>
